export default function Numpad({ currentScore, isFarkle, onNumKey, onDelete, onBank, onFarkle, bankLabel }) {
  const nums = ['1','2','3','4','5','6','7','8','9'];

  const label = isFarkle
    ? 'Turn Over'
    : bankLabel ?? `Bank ${currentScore.toLocaleString()} Points`;

  return (
    <div className="numpad-container">
      <div className="numpad-grid">
        {nums.map(n => (
          <button key={n} className="num-key" onClick={() => onNumKey(n)}>{n}</button>
        ))}
        <button className="num-key key-farkle" onClick={onFarkle}>NO DICE!</button>
        <button className="num-key" onClick={() => onNumKey('0')}>0</button>
        <button className="num-key key-action" onClick={onDelete}>&#9003;</button>
      </div>
      <button
        className={`btn-bank ${isFarkle ? 'btn-farkle-state' : ''}`}
        onClick={onBank}
      >
        {label}
      </button>
    </div>
  );
}
